/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DistanceReferKey } from './distanceReferKey';


export interface ScoreRefer { 
    id: string;
    type: ScoreRefer.TypeEnum;
    values?: object;
    distanceKeys?: Array<DistanceReferKey>;
    terrainBands?: Array<object>;
}
export namespace ScoreRefer {
    export type TypeEnum = 'keyValue' | 'average' | 'coordinate' | 'area' | 'percentile' | 'terrainCoordinate';
    export const TypeEnum = {
        KeyValue: 'keyValue' as TypeEnum,
        Average: 'average' as TypeEnum,
        Coordinate: 'coordinate' as TypeEnum,
        Area: 'area' as TypeEnum,
        Percentile: 'percentile' as TypeEnum,
        TerrainCoordinate: 'terrainCoordinate' as TypeEnum
    };
}


